import React, { useCallback, useEffect, useRef, useState } from 'react';

import { HexColorPicker } from "react-colorful";

import DateFnsUtils from '@date-io/date-fns';

import { grey, lightGreen, red } from '@mui/material/colors';

import { makeStyles }   from '@material-ui/core/styles';
import Button           from '@material-ui/core/Button';
import Card             from '@material-ui/core/Card';
import CardActions      from '@material-ui/core/CardActions';
import CardContent      from '@material-ui/core/CardContent';
import Dialog           from '@material-ui/core/Dialog';
import DialogActions    from '@material-ui/core/DialogActions';
import DialogContent    from '@material-ui/core/DialogContent';
import DialogTitle      from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid             from '@material-ui/core/Grid';
import IconButton       from '@material-ui/core/IconButton';
import InputAdornment   from '@material-ui/core/InputAdornment';
import Switch           from '@material-ui/core/Switch';
import TextField        from '@material-ui/core/TextField';
import Typography       from '@material-ui/core/Typography';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import FormatColorFillIcon  from '@material-ui/icons/FormatColorFill';

import { KeyboardDateTimePicker }  from '@material-ui/pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import { create, date } from './util';

const style = {
  newTicket: makeStyles((theme) => ({
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4),
    },
    title: {
      alignItems: 'center',
      display: 'flex',
    },
    ticketInfo: {
      display: 'flex',
      gap: theme.spacing(2),
    },
    ticketInfoName: {
      flexGrow: 1,
    },
  })),
  issuedTicket: makeStyles((theme) => ({
    info: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
    },
    notPaid: {
      alignItems: 'center',
      color: red[400],
      display: 'flex',
      marginLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    root: {
      alignItems: 'center',
      borderLeftWidth: theme.spacing(1),
      borderStyle: 'solid',
      borderWidth: theme.spacing(0.1),
      display: 'inline-flex',
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      padding: theme.spacing(1),
    },
    title: {
      display: 'flex',
      gap: theme.spacing(2),
    },
    titleRowid: {
      color: grey[400],
      paddingLeft: theme.spacing(1),
    },
    usedAt: {
      color: grey[400],
    },
  })),
  ticket: makeStyles((theme) => ({
    cardArctions : {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2),
      width: '100%',
    },
    ticketNote: {
      margin: theme.spacing(1),
    },
  })),
  tickets: makeStyles((theme) => ({
    card: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
    },
    root: {
      flexGrow: 1,
      padding: theme.spacing(16),
    },
  })),
};

function NewTicket(props) {
  const classes = style.newTicket();

  return (
    <Dialog fullWidth open={props.newTicket.rowid >= -1}>
      <DialogTitle>

        <div className={classes.title}>
          <Typography variant="h6">
            {props.newTicket.rowid === -1 ? '새 티켓 추가' : '티켓 수정'}
          </Typography>

          {props.newTicket.rowid > -1 && <Button color="secondary"
            disabled={!props.newTicket.deletable}
            onClick={(event) => { props.deleteTicket(); }}
          >{'삭제'}</Button>}
        </div>

      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <FormControlLabel label={props.newTicket.issuable ? '발행 가능' : '발행 불가능'}
          control={
            <Switch checked={props.newTicket.issuable}
              color="primary"
              onChange={(event) => {
                props.setNewTicket({...props.newTicket, issuable: !props.newTicket.issuable});
              }}
            />
          }
        />
        <div className={classes.ticketInfo}>
          <TextField className={classes.ticketInfoName}
            label={'티켓 이름'}
            onChange={(event) => { props.setNewTicket({...props.newTicket, name: event.target.value}); }}
            value={props.newTicket.name}
          />
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FormatColorFillIcon style={{color: props.newTicket.color}} />
                </InputAdornment>
              ),
            }}
            label={'티켓 색상'}
            value={props.newTicket.color}
            onClick={(event) => {
              props.setNewTicket({...props.newTicket, changingColor: true});
            }}
          />
        </div>

        <TextField fullWidth key={props.newTicket.id + 'note'}          
          label={'설명'}
          multiline rows={4}
          onChange={(event) => { props.setNewTicket({...props.newTicket, note: event.target.value}); }}
          value={props.newTicket.note}
        />
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDateTimePicker format="yyyy/MM/dd hh:mm a"
            label={'유효 기간 시작'}
            onChange={(datetime) => {
              props.setNewTicket({...props.newTicket, activeFrom: datetime.getTime()});
            }}
            value={new Date(props.newTicket.activeFrom)}
          />
        </MuiPickersUtilsProvider>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDateTimePicker format="yyyy/MM/dd hh:mm a"
            label={'유효 기간 끝'}
            onChange={(datetime) => {
              props.setNewTicket({...props.newTicket, activeUntil: datetime.getTime()});
            }}
            value={new Date(props.newTicket.activeUntil)}
          />
        </MuiPickersUtilsProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={(event) => { props.setNewTicket(create.ticket()); }}>
          {'취소'}
        </Button>
        <Button color="primary" onClick={(event) => { props.updateTicket(); }}>
          {'확인'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function NewTicketColor(props) {
  const [ color, setColor ] = useState(props.newTicket.color);

  useEffect(() => {
    setColor(props.newTicket.color);
  }, [props.newTicket.color]);

  return (
    <Dialog open={props.newTicket.rowid >= -1 && props.newTicket.changingColor}
    >
      <DialogContent>
        <HexColorPicker color={color}
          onChange={setColor}
        />
      </DialogContent>
      <DialogContent>
        <TextField value={color}
          onChange={(event) => { setColor(event.target.value); }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={(event) => {
          props.setNewTicket({...props.newTicket, changingColor: false});
        }}>
          {'취소'}
        </Button>
        <Button color="primary" onClick={(event) => {
          props.setNewTicket({...props.newTicket, changingColor: false, color});
        }}>
          {'확인'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Ticket(props) {
  const classes = style.ticket();

  return (
    <Card className={classes.root}
      style={{
        backgroundColor: props.ticket.issuable ? 'white' : '#EEEEEE',
        opacity: props.ticket.issuable ? 1.0 : 0.5,
      }}
    >
      <CardContent>
        <IssuedTicket ticket={create.issuedTicket({
          activeFrom: props.ticket.activeFrom,
          activeUntil: props.ticket.activeUntil,
          color: props.ticket.color,
          name: props.ticket.name,
          rowid: 0,
        })} />

        <div className={classes.ticketNote}>
          {props.ticket.note.split('\n').map((line, index) => (
            <Typography variant="body1" key={index}
              color="textSecondary"
            >{line}</Typography>
          ))}
        </div>
      </CardContent>
      <CardActions className={classes.cardArctions}>
        <Button color='primary'
          onClick={(event) => { props.setNewTicket({...props.ticket}); }}
        >{'수정'}</Button>
      </CardActions>
    </Card>
  );
}

export default function Tickets(props) {
  const classes = style.tickets();

  const [ newTicket, setNewTicket ] = useState(create.ticket());
  const {
    path,
    request,
    setSnackbarMessage,
    setTickets,
    ticketer,
    tickets
  } = props.context.getStates();

  const newTicketRef = useRef(null);

  function deleteTicket() {
    request.postSecurely('/ticket/delete', {
      ...newTicket,
      ticketer,
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else {
        setSnackbarMessage('티켓을 삭제하였습니다.');
        setNewTicket(create.ticket());
      }
    });
  }

  function updateTicket() {
    request.postSecurely('/ticket/update', {
      ...newTicket,
      ticketer,
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else {
        if (newTicket.rowid === -1) {
          setSnackbarMessage('티켓을 추가하였습니다.');
        } else {
          setSnackbarMessage('티켓을 수정하였습니다.');
        }
        setNewTicket(create.ticket());
      }
    });
  }

  const fetchTickets = useCallback(() => {
    request.postSecurely('/ticket/select', {
      ticketer,
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else if ('tickets' in response)  {
        let tickets = [];
        for (const ticket of response.tickets) {
          tickets.push(create.ticket({
            activeFrom : ticket['ticket.active_from'],
            activeUntil: ticket['ticket.active_until'],
            color      : ticket['ticket.color'],
            issuable   : [false, true][ticket['ticket.issuable']],
            name       : ticket['ticket.name'],
            note       : ticket['ticket.note'],
            rowid      : ticket['ticket.rowid'],

            deletable: ticket['issued.rowid'] === null,
          }));
        }
        setTickets(tickets);
      }
    });
  }, [
    request,
    setTickets,
    ticketer,
  ]);

  useEffect(() => {
    fetchTickets();
  }, [
    fetchTickets,
    newTicket.rowid,
  ]);

  if (path === '/tickets') {
    return (<>
      <NewTicket newTicket={newTicket}
        deleteTicket={deleteTicket}
        setNewTicket={setNewTicket}
        updateTicket={updateTicket}
      />

      <NewTicketColor newTicket={newTicket}
        setNewTicket={setNewTicket}
      />
      
      <div className={classes.root}>
        <Grid container direction="row"
          alignItems="stretch"
          spacing={4}
        >
          <Grid item xs={3}>
            <Card className={classes.card} ref={newTicketRef}>
              <Typography variant="h6" component="h6">
                {'새 티켓 추가'}
              </Typography>
              <IconButton color="primary" component="span"
                onClick={(event) => {
                  setNewTicket(create.ticket({rowid: -1}));
                }}
              ><AddCircleOutlineIcon
                fontSize="large"
                style={{color: lightGreen[400]}}
              /></IconButton>
            </Card>
          </Grid>
          {tickets.map((ticket) => (
            <Grid item xs={3} key={ticket.rowid}>
              <Ticket ticket={ticket}
                setNewTicket={setNewTicket}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </>);
  } else {
    return null;
  }
}

export function IssuedTicket(props) {
  const classes = style.issuedTicket();

  return (
    <div className={classes.root} style={{
      borderColor: props.ticket.usedAt === 0 ? props.ticket.color : grey[400],
    }}>
      <div className={classes.titleRowid}>
        {`#${props.ticket.rowid}`}
      </div>
      <div className={classes.info}>
        <div className={classes.title}>
          <b>{props.ticket.name}</b>
        </div>
        {props.ticket.usedAt > 0 && (
          <div className={classes.usedAt}>
            {props.ticket.usable ? (
              <span>
                {date.used(props.ticket.usedAt)}
                {' 사용'}
              </span>
            ) : (
              <strike style={{color: 'lightgray'}}>
                {date.used(props.ticket.usedAt)}
                {' 만료'}
              </strike>
            )}
          </div>
        )}
        {(
          props.ticket.activeFrom > 0 &&
          props.ticket.activeUntil > 0
        ) && (
          <div className={classes.usedAt}>
            <span>{'유효기간: '}</span>
            <span>{date.withoutTime(props.ticket.activeFrom)}</span>
            <span>{'~'}</span>
            <span>{date.withoutTime(props.ticket.activeUntil)}</span>
          </div>
        )}
      </div>
      {props.ticket.paidMethod === '미결제' && (
        <div className={classes.notPaid}>
          <span>{'미결제'}</span>
        </div>
      )}
    </div>
  );
}